<template>
  <AppSelect v-model="year" :options="listYear" class="w-24 mt-3" />
</template>
<script setup>
import AppSelect from "@/components/AppSelect.vue";
import { useMainStore } from "@/store/main";
import { storeToRefs } from "pinia";
import { ref, onMounted } from "vue";

const store = useMainStore();

const { year } = storeToRefs(store);

const listYear = ref([]);

onMounted(() => {
  const currentYear = new Date().getFullYear().toString();
  for (var year = 2021; year <= currentYear; year++) {
    listYear.value.push({
      title: `${year}`,
      value: `${year}`,
    })
  }
});
</script>
